module.exports = __webpack_public_path__ + "img/1111170120-logo.26c84fa8.png";